import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { LanguageService } from '../../services/language.service';

/**
 * GuestLanguageGuard — ensures guest page is always English.
 * Before activating /guest, checks current language; if not 'en', switches to 'en'.
 * This covers cases where logout didn't fire (e.g. direct /guest navigation,
 * stale storage, or external link) and guarantees guest is English.
 * Used as canActivate on the guest route.
 */
export const guestLanguageGuard: CanActivateFn = async () => {
  const languageService = inject(LanguageService);
  try {
    if (languageService.currentLang !== 'en') {
      await languageService.setLanguage('en');
    }
  } catch (e) {
    console.warn('[guestLanguageGuard] failed to reset language to en', e);
  }
  return true;
};
